/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientsPhysiciansViewModel } from './PatientsPhysiciansViewModel'; 

export function getPatientPhysiciansOptions(stayId: string, onSuccess?: (result: PatientsPhysiciansViewModel) => void) {
	return queryOptions({
		queryKey: ['patient-physicians', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/demographics/patientsphysicians/queries/getpatientphysicians/' + stayId;
			const resp = await axios.get<PatientsPhysiciansViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}